import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router-dom";

export default function PreCheck() {
  const navigate = useNavigate();
  const { aid } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [permissionsGranted, setPermissionsGranted] = useState(false);

  // 📍 Request Permissions
  const requestPermissions = async () => {
    try {
      setLoading(true);

      // 🎥 Camera + Mic
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      // Stop immediately (just for permission)
      stream.getTracks().forEach((track) => track.stop());

      // 📍 Location
      await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos),
          (err) => reject(err)
        );
      });

      setPermissionsGranted(true);
      alert("All permissions granted ✅");
    } catch (err) {
      console.error(err);
      alert("Permissions are required to continue ❌");
    } finally {
      setLoading(false);
    }
  };

  // 🚀 Start Survey
  const startSurvey = () => {
    if (!permissionsGranted || !consent) {
      alert("Please accept consent and grant permissions");
      return;
    }

    navigate(`/insured/${aid}`);
  };

  return (
    <Box
      sx={{
        height: "100vh",
        background: "#000",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        px: 3,
      }}
    >
      <Typography variant="h5" mb={2}>
        Case Details
      </Typography>

      <Typography variant="body1" mb={3}>
        Claim ID: {aid} <br />
        Please allow camera, microphone, and location access to proceed with
        the live survey.
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            sx={{ color: "#fff" }}
          />
        }
        label="I agree to share my camera, microphone, and location for survey purposes"
      />

      {!permissionsGranted && (
        <Button
          variant="contained"
          onClick={requestPermissions}
          disabled={loading}
          sx={{ mt: 3 }}
        >
          {loading ? "Requesting..." : "Allow Permissions"}
        </Button>
      )}

      <Button
        variant="contained"
        color="success"
        onClick={startSurvey}
        disabled={!permissionsGranted || !consent}
        sx={{ mt: 2 }}
      >
        Start Survey
      </Button>
    </Box>
  );
}